import { render } from "./SelectDropdown.vue?vue&type=template&id=3a6f8dd4"
import script from "./SelectDropdown.vue?vue&type=script&lang=js"
export * from "./SelectDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app.rizome-bxl.be/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__